/**
 * Converts any string into a URL-safe slug.
 * e.g. "Custom Pillow Cover!" → "custom-pillow-cover"
 */
export const slugify = (text) =>
  (text || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')   // remove non-alphanumeric chars
    .replace(/\s+/g, '-')            // spaces → hyphens
    .replace(/-+/g, '-')             // collapse consecutive hyphens
    .replace(/^-+|-+$/g, '');        // trim leading/trailing hyphens

/**
 * Returns the /shop URL for a category using a slug instead of numeric id.
 * Falls back to the numeric id only if no title is available.
 *
 * @param {object} category - { id, title }
 * @returns {string} e.g. "/shop?category=pillow-cover"
 */
export const getCategoryUrl = (category) => {
  if (!category) return '/shop';
  const slug = slugify(category.title);
  return `/shop?category=${slug || category.id}`;
};

/**
 * Returns the canonical URL path for a product.
 * Priority:
 *  1. Admin-set urlSlug
 *  2. Auto-generated slug from product name
 *  3. Numeric id (last resort — should rarely be reached)
 *
 * @param {object} product - { id, name?, urlSlug?, url_slug? }
 * @returns {string} e.g. "/product/custom-pillow-cover"
 */
export const getProductUrl = (product) => {
  if (!product) return '/shop';
  const adminSlug  = product.urlSlug || product.url_slug;
  if (adminSlug)   return `/product/${adminSlug}`;
  const nameSlug   = slugify(product.name);
  if (nameSlug)    return `/product/${nameSlug}`;
  return `/product/${product.id}`;
};
